// @flow

import React from 'react';
import styled from 'styled-components';
import { colors, padding } from 'seedling/constants';

export type TextAreaProps = {
  block: boolean,
  disabled: boolean,
  inputRef: () => void,
  focusBorderColor: string,
  resize: string,
};

export default class TextArea extends React.Component<TextAreaProps> {
  static defaultProps = {
    block: false,
    inputRef: () => {},
    focusBorderColor: colors.mediumGreenhouseGreen,
    resize: 'none',
  };

  render() {
    const { disabled, block, inputRef, ...restProps } = this.props;
    const ComponentType = block ? BlockTextAreaElem : TextAreaElem;

    // innerRef is the styled-components hacky way to "pass-thru" the `ref`
    return (
      <ComponentType innerRef={inputRef} disabled={disabled} {...restProps} />
    );
  }
}

const TextAreaElem = styled.textarea`
  resize: ${props => props.resize};

  // to prevent Mozilla and other browsers from making font 'monospace' or some other
  // arbitrarily defined browser style
  font-family: inherit;
  font-size: 14px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 2px;
  padding: ${padding.small};
  max-width: 100%;
  height: 100px;
  min-height: 100px;
  color: ${colors.darkestGrey};

  &:focus {
    border-color: ${props => props.focusBorderColor};
    outline: none;
  }
`;

const BlockTextAreaElem: typeof TextAreaElem = styled(TextAreaElem)`
  display: block;
  width: 100%;
  box-sizing: border-box;
`;
